export default __webpack_public_path__ + "static/grapeseed_forgery-fdebec3aecede919598193c921ff9724.png";